export default __webpack_public_path__ + "static/bg-2-ab387b97db113add971c4ce6fcea01ea.jpg";